import { formatDate } from '@roc/feature-utils';
import { DataGrid, GridColumnProps } from '@roc/ui';
import { formatCurrency } from '@roc/ui/utils';
import { observer } from 'mobx-react';

const DATE_FORMAT = 'MM/dd/yyyy';

const wrapColumn: Partial<GridColumnProps> = {
  wrapText: true,
  autoHeight: true,
  cellStyle: {
    whiteSpace: 'normal',
    wordBreak: 'break-word',
    lineHeight: '1.4',
    paddingTop: 12,
    paddingBottom: 12,
  },
};

const columns: GridColumnProps[] = [
  { field: 'actionDate', headerName: 'Action Date', minWidth: 130, cellRenderer: 'dateCellRenderer' },
  { field: 'purchaseDate', headerName: 'Purchase Date', minWidth: 130, cellRenderer: 'dateCellRenderer' },
  { field: 'sellDate', headerName: 'Sell Date', minWidth: 130, cellRenderer: 'dateCellRenderer' },
  { field: 'recordingDate', headerName: 'Recording Date', minWidth: 140, cellRenderer: 'dateCellRenderer' },
  { field: 'description', headerName: 'Description', minWidth: 220 },
  { field: 'propertyType', headerName: 'Property Type', minWidth: 200 },
  { field: 'seller', headerName: 'Seller', minWidth: 200 },
  { field: 'buyer', headerName: 'Buyer', minWidth: 200 },
  { field: 'lender', headerName: 'Lender', minWidth: 220 },
  { field: 'loanAmount', headerName: 'Loan Amount', minWidth: 140, cellRenderer: 'currencyCellRenderer' },
  { field: 'sellPrice', headerName: 'Seller Price', minWidth: 140, cellRenderer: 'currencyCellRenderer' },
  { field: 'interestRate', headerName: 'Interest Rate', minWidth: 120, cellRenderer: 'percentageCellRenderer' },
].map(column => ({ ...wrapColumn, ...column } as GridColumnProps));

const isBlank = value => value === null || value === undefined || value === '';

const frameworkComponents = {
  dateCellRenderer: ({ value }) => (value ? formatDate(value, DATE_FORMAT) : ''),
  currencyCellRenderer: ({ value }) => (isBlank(value) ? '' : formatCurrency(value, 0)),
  percentageCellRenderer: ({ value }) => (isBlank(value) ? '' : `${Number(value).toFixed(2)}%`),
};

interface TitleHistoryLookupGridProps {
  rows: any[];
  isLoading?: boolean;
}

export const TitleHistoryLookupGrid = observer(({ rows, isLoading }: TitleHistoryLookupGridProps) => {
  return (
    <DataGrid
      columns={columns}
      rows={rows}
      rowData={rows}
      rowModelType="clientSide"
      isLoading={isLoading}
      domLayout="autoHeight"
      frameworkComponents={frameworkComponents}
    />
  );
});
